export const REVIEW_TYPES = {
  ATTORNEY_ACTIVITIES: 'attorney_activities',
  COMPANY_DATA: 'company_data',
  PROCESS_DATA: 'process_data',
  SCORE_BOARD: 'score_board',
  FAMILY_RELATION_DATA: 'family_relation_data',
  FINANCIAL_PENDINGS_DATA: 'financial_pendings_data',
  SOCIAL_NETWORKS: 'social_networks',
  COMPLIANCE_LIST: 'compliance_list',
  PEP: 'pep',
  NEGATIVE_MEDIA: 'negative_media',
  RESTRICTIVE_LIST: 'restrictive_list',
  REPRESENTATION_ACTIVITY: 'representation_activity',
  EXTERNAL_ACTIVITIES: 'external_activities',
  ADDRESS_OCR_DATA: 'address_ocr_data',
}
